document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.getElementById('hype-smooth-wrapper');
  if (wrapper) {
    wrapper.classList.remove('hype-initial-opacity');
    wrapper.classList.add('hype-body-fade-in');
  }

  gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother, ScrollToPlugin);

  //control the smooth behavior on desktop and mobile
  let smoother;
  if (window.innerWidth > 900) {
    smoother = ScrollSmoother.create({
      smooth: 1.5,
      effects: true,
      wrapper: "#hype-smooth-wrapper",
      content: "#hype-smooth-content",
      normalizeScroll: true
    });
  }else {
    smoother = ScrollSmoother.create({
      smooth: 1,
      effects: true,
      smoothTouch: true,
      wrapper: "#hype-smooth-wrapper",
      content: "#hype-smooth-content",
      normalizeScroll: false
    });
  }

/*-------------------- 1st section starts --------------------*/
gsap.set(".video-container", { backgroundColor: "transparent" });
gsap.set(".video-container .hype-h3, .video-container .hype-h1, .video-container .hype-cta", { opacity: 0, y: 50 });

let animationTriggered = false;
let isAnimating = false;

let videoTl = gsap.timeline({
  paused: true,
  onComplete: () => {
    isAnimating = false;
    if (smoother) smoother.paused(false);
  }
});

// Animation sequence for the video section
videoTl
  .to(".video-container", { backgroundColor: "#00000033", duration: 0.3, ease: "power2.inOut" }) // keep 0.4
  .to(".video-container .hype-h3", { opacity: 1, y: 0, duration: 0.3 }) // keep 0.4
  .to(".video-container .hype-h1", { opacity: 1, y: 0, duration: 0.3 }, "+=0.3") // keep 0.4
  .to(".video-container .hype-cta", { opacity: 1, y: 0, duration: 0.3 }, "+=0.3") // keep 0.4
  .to(
    ".hype-cta",
    {
      backgroundPosition: "calc(-28%) center",
      color: "#fff",
      duration: 0.3, // keep 0.4
      ease: "ease-in-out",
    },
    "+=0.2"
  );

function initAnimation() {
  const isLargeScreen = window.matchMedia("(min-width: 901px)").matches;

  if (isLargeScreen) {
    let scrollStartPosition = 0;
    let hasScrolled = false;

    // Function to handle scroll events
    function handleScroll(e) {
      if (!hasScrolled) {
        hasScrolled = true;
        scrollStartPosition = window.scrollY || document.documentElement.scrollTop;

        // Prevent the initial scroll
        if (e.type === "wheel") {
          e.preventDefault();
        }
      }

      if (!animationTriggered && hasScrolled && !isAnimating) {
        const currentScrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (Math.abs(currentScrollPosition - scrollStartPosition) > 5) {
          // Reduced threshold
          animationTriggered = true;
          isAnimating = true;
          if (smoother) smoother.paused(true);
          videoTl.play();

          // Scroll back to the start position
          window.scrollTo(0, scrollStartPosition);
        }
      }
    }

    // Add scroll event listeners
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("wheel", handleScroll, { passive: false });

    // Prevent default scroll behavior during animation
    window.addEventListener(
      "wheel",
      (e) => {
        if (isAnimating) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      },
      { passive: false }
    );
  } else {
    animationTriggered = true;
    videoTl.play();
  }
}

initAnimation();

const ctaButton = document.querySelector(".hype-cta");

ctaButton.addEventListener("mouseenter", function () {
  if (animationTriggered) {
    ctaButton.style.backgroundPosition = "calc(28%) center";
    ctaButton.style.color = "inherit";
  } else {
    ctaButton.style.backgroundPosition = "calc(-28%) center";
    ctaButton.style.color = "#fff";
  }
});

ctaButton.addEventListener("mouseleave", function () {
  if (animationTriggered) {
    ctaButton.style.backgroundPosition = "calc(-28%) center";
    ctaButton.style.color = "#fff";
  } else {
    ctaButton.style.backgroundPosition = "calc(28%) center";
    ctaButton.style.color = "inherit";
  }
});


/*-------------------- 2nd section starts --------------------*/
// Animation for hype-animate-text section
const splitText = new SplitText(".hype-animate-text", { 
  type: "words", 
  wordsClass: "split-word",
  span: true  // This ensures spans are split as well
});
const words = splitText.words;

gsap.set(words, { opacity: 0.4 });

let textTl = gsap.timeline({
  scrollTrigger: {
    trigger: "#animate-scroll",
    start: "top top",
    end: "bottom top",
    scrub: true,
    pin: true,
    pinSpacing: true,
    markers: false // Set to false for production
  }
});

words.forEach((word, i) => {
  textTl.to(word, { 
    opacity: 1, 
    duration: 0.1 
  }, i * 0.1);
});

/*-------------------- 3rd section starts --------------------*/
gsap.set("#animate-text-counters .counters-container .hype-h1, #animate-text-counters .counters-container > p, #animate-text-counters .counters-container .hype-counters", { opacity: 0, y: 50 });

// Function to animate number
function animateNumber(target, end, duration) {
  return gsap.to(target, {
    innerText: end,
    duration: duration,
    snap: { innerText: 1 },
    onUpdate: function() {
      this.targets()[0].innerText = Math.round(this.targets()[0].innerText);
    }
  });
}

let countersTl = gsap.timeline({
  scrollTrigger: {
    trigger: "#animate-text-counters",
    start: "top 50%",
    markers: false, // Set to false for production
    once: true
  }
});

// Overlapping animations by adjusting the relative timing
countersTl
  .to("#animate-text-counters .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
  .to("#animate-text-counters p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.4") // Start slightly earlier
  .to("#animate-text-counters .hype-counters", { opacity: 1, y: 0, duration: 0.5 }, "-=0.4") // Overlap more with previous animations
  .addLabel("startCounting", "-=0.2") // Start counting earlier
  .add(animateNumber("#animate-text-counters .hype-counters-element:nth-child(1) h2", 14, 1), "startCounting")
  .add(animateNumber("#animate-text-counters .hype-counters-element:nth-child(2) h2", 3, 1.05), "startCounting")
  .add(animateNumber("#animate-text-counters .hype-counters-element:nth-child(3) h2", 8, 1.25), "startCounting")
  .to("#animate-text-counters .hype-counters-element:nth-child(3) .hype-plus-sign", { opacity: 1, duration: 0.5 }, "startCounting");

// Animation for the header when the text animation completes
countersTl.to("#header-wrapper .hype-sticky-header", {
  y: 0,
  opacity: 1,
  duration: 1,
  ease: "power2.out",
  onStart: function() {
    gsap.set("#header-wrapper .hype-sticky-header", { y: -150, opacity: 0 });
  }
});

/*-------------------- 5th section starts --------------------*/
gsap.set("#animate-text-nocounters .hype-h1, #animate-text-nocounters p", { opacity: 0, y: 50 });

  let noCountersTl = gsap.timeline({
    scrollTrigger: {
      trigger: "#animate-text-nocounters",
      start: "top 70%",
      markers: false, // Set to false for production
      once: true
    }
  });

  noCountersTl
    .to("#animate-text-nocounters .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
    .to("#animate-text-nocounters p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");

  // Set initial state
gsap.set(".hype-video-scroll-container", { width: "70vw" });
gsap.set(".hype-video-scroll-content", { borderRadius: "60px" });

/*-------------------- 6th section starts --------------------*/
gsap.set("#animate-video-scroll .hype-h1, #animate-video-scroll p", { opacity: 0, y: 50 });

let videoScrollTextTl = gsap.timeline({
  scrollTrigger: {
    trigger: "#animate-video-scroll",
    start: "top 70%",
    markers: false,
    once: true
  }
});

videoScrollTextTl
  .to("#animate-video-scroll .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
  .to("#animate-video-scroll p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");

// Expansion animation
let expansionTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".hype-video-scroll-container",
    start: "top 80%",
    end: "bottom 40%",
    scrub: true,
    markers: false,
    toggleActions: "play none none reverse",
  }
});

expansionTl
  .to(".hype-video-scroll-container", { width: "100vw", ease: "none" })
  .to(".hype-video-scroll-content", { borderRadius: "0px", ease: "none" }, 0)
  .to("#header-wrapper .hype-sticky-header", {
    opacity: 0,
    pointerEvents: "none",
    duration: 1,
    ease: "power2.out",
    onComplete: function() {
      console.log("Header faded out");
    }
  }, 0);

// Contraction animation for width and border-radius
let contractionTl = gsap.timeline({
  scrollTrigger: {
    trigger: ".hype-video-scroll-container",
    start: "bottom 80%",
    end: "bottom -80%",
    scrub: true,
    markers: false,
    toggleActions: "play none none reverse",
  }
});

contractionTl
  .to(".hype-video-scroll-container", { width: "70vw", ease: "none" })
  .to(".hype-video-scroll-content", { borderRadius: "60px", ease: "none" }, 0);

// Separate scrollTrigger for #header-wrapper .hype-sticky-header
gsap.to("#header-wrapper .hype-sticky-header", {
  scrollTrigger: {
    trigger: ".hype-video-scroll-container",
    start: "bottom -100%",
    end: "bottom -130%", // Adjust to 100vh after the initial trigger point
    scrub: true,
    markers: false,
    toggleActions: "play none none reverse",
  },
  opacity: 1,
  pointerEvents: "auto",
  duration: 1,
  ease: "power2.out",
  onReverseComplete: function() {
    console.log("Header faded in");
  }
});


// Pinning effect
ScrollTrigger.create({
  trigger: ".hype-video-scroll-container",
  start: "top top",
  end: "+=80%", // Adjust this value to control how long the section stays pinned
  pin: true,
  pinSpacing: true,
  markers: false, // Set to false for production
});


/*-------------------- 8th section starts --------------------*/
gsap.set("#animate-text-montage .hype-h1, #animate-text-montage .counters-container > p", { opacity: 0, y: 50 });

    let montageNoCountersTl = gsap.timeline({
      scrollTrigger: {
        trigger: "#animate-text-montage",
        start: "top 70%",
        markers: false, // Set to false for production
        once: true
      }
    });

    montageNoCountersTl
      .to("#animate-text-montage .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
      .to("#animate-text-montage p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");


/*-------------------- 10th section starts --------------------*/
gsap.set("#animate-text-drop-spin .hype-h1, #animate-text-drop-spin p", { opacity: 0, y: 50 });

let dropSpinTl = gsap.timeline({
  scrollTrigger: {
    trigger: "#animate-text-drop-spin",
    start: "top 70%",
    markers: false, // Set to false for production
    once: true
  }
});

dropSpinTl
  .to("#animate-text-drop-spin .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
  .to("#animate-text-drop-spin p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");


/*-------------------- 11th section starts --------------------*/
gsap.set("#animate-chair-scroll .hype-h1, #animate-chair-scroll p", { opacity: 0, y: 50 });

  let headrestText = gsap.timeline({
    scrollTrigger: {
      trigger: "#animate-chair-scroll",
      start: "top 70%",
      markers: false, // Set to false for production
      once: true
    }
  });

  headrestText
    .to("#animate-chair-scroll .hype-h1", { opacity: 1, y: 0, duration: 0.5 })
    .to("#animate-chair-scroll p", { opacity: 1, y: 0, duration: 0.5 }, "-=0.3");


    /* Play / pause video on scroll for both scroll and no-scroll video sections */
    const videoElements = document.querySelectorAll('.hype-video-scroll-content, .hype-video-noscroll-content');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const videoElement = entry.target;
        if (!entry.isIntersecting && !videoElement.paused) {
          //when video is out of view and playing, pause the video
          videoElement.pause();
          $(videoElement).siblings('.custom-video-play').fadeIn();
          $('.hype-sticky-header').fadeIn();
        }
      });
    }, {
      threshold: [0.5] //pause the video when less than 50% is visible
    });
    
    videoElements.forEach((videoElement) => {
      if (videoElement) {
        observer.observe(videoElement); //start observing the video element
    
        gsap.to(videoElement, {
          scrollTrigger: {
            trigger: videoElement.closest('.hype-video-scroll-section, .hype-video-noscroll-container'),
            start: "top 50%",
            end: "bottom 50%",
            onEnter: () => {
            },
            onLeave: () => {
              if (!videoElement.paused) {
                videoElement.pause();
                $(videoElement).siblings('.custom-video-play').fadeIn();
                $('.hype-sticky-header').fadeIn();
              }
            },
            onEnterBack: () => {
            },
            markers: false,
            toggleActions: "play none none reverse"
          }
        });
      }
    });


});
/*---------- GSAP END ---------- */

window.onbeforeunload = function () {
  // Add fade-out class to #hype-smooth-wrapper before unloading
  const wrapper = document.getElementById('hype-smooth-wrapper');
  if (wrapper) {
      wrapper.classList.remove('hype-body-fade-in');
      wrapper.classList.add('hype-body-fade-out');
  }

  // Use a timeout to scroll to the top after the fade-out effect
  setTimeout(function () {
      window.scrollTo(0, 0);
  }, 250); // Match the duration of the CSS transition
};

/*play button for desktop*/
if ($('.hype-video-scroll-section .custom-video-play').length > -1) {
  if (window.innerWidth > 100) {
    // Play button click
    $('.hype-video-scroll-section .custom-video-play').on('click', function () {
      var videoElement = $(this).siblings('video').get(0);
      var self = $(this);
      videoElement.play();
      self.fadeOut();
      $('.hype-sticky-header').fadeOut();
    });

    // Video click for toggling play/pause
    $('.hype-video-scroll-section video').on('click', function () {
      var videoElement = $(this).get(0);
      if (videoElement.paused) {
        videoElement.play();
        $(this).siblings('.custom-video-play').fadeOut();
        $('.hype-sticky-header').fadeOut();
      } else {
        videoElement.pause();
        $(this).siblings('.custom-video-play').fadeIn();
        $('.hype-sticky-header').fadeIn();
      }
    });

    // When video is paused
    $('.hype-video-scroll-section video').on('pause', function () {
      $(this).siblings('.custom-video-play').fadeIn();
      $('.hype-sticky-header').fadeIn();
    });
  } else {
    $('.hype-video-scroll-section .custom-video-play').remove();
  }
}

/* Update styling of sticky bar */

document.addEventListener('DOMContentLoaded', function() {
  let buttonText = 'Shop now';
  document.querySelector('#sticky-atc').setAttribute('data-style', `${document.querySelector('#hype-smooth-wrapper').getAttribute('data-header-style')}`)
  if(document.querySelector('#hype-smooth-wrapper').getAttribute('data-header-style') != "swatches"){
    buttonText  = document.querySelector('#hype-smooth-wrapper').getAttribute('data-non-swatch-button-text');
  }
  let html = `<a href="/products/${document.querySelector('#hype-smooth-wrapper').getAttribute('data-product-handle')}" class="btn product-tile__button " shop-now-plp="" promo-style="true" promo-style-on-hover="true" data-extra-bottom-margin="true" data-updated="true"><span>${buttonText}</span></a>`
  document.querySelectorAll('.sticky-atc__button-container')[1].remove();
  document.querySelectorAll('.sticky-atc__button-container')[0].innerHTML = html;
  

  if(document.querySelector('.stamped-product-reviews-badge')){
    document.querySelector('.stamped-product-reviews-badge').remove();
  }
  let subtitleText = document.querySelector('#hype-smooth-wrapper').getAttribute('data-header-subtitle-text');
  let headerHTML = `
        <div class="hype-sticky-header__subtitle-container">
          <p>${subtitleText}</p>
        </div>`
  document.querySelector('.sticky-atc__desktop-header').insertAdjacentHTML('beforeend', headerHTML)
});

/* Attach header swatches to variant inspect section */

document.addEventListener('DOMContentLoaded', function() {
  const elements = document.querySelectorAll('#sticky-atc .swatch-dropdown__sliding-option-selector-element');

  elements.forEach(function(element) {
      element.addEventListener('click', function(event) {
          const dataKey = element.getAttribute('data-key');
          const inputElement = element.querySelector('input');
          const value = inputElement ? inputElement.value : null;

          if (dataKey && value) {
              const swatchContainer = document.querySelector(`.variant-inspect .swatch[data-option-name="${dataKey}"]`);
              if (swatchContainer) {
                  const targetSwatchElement = swatchContainer.querySelector(`.swatch-element[data-value="${value}"] label`);
                  if (targetSwatchElement) {
                      targetSwatchElement.click();
                  }
              }
          }
      });
  });

  /* Drop, spin, and pull section videos will play only when video tag is fully visible in the viewport */

const videos = document.querySelectorAll('.hype-video-portrait');

function handleVideos() {
  const isLargeScreen = window.matchMedia("(min-width: 901px)").matches;

  if (isLargeScreen) {
    // Only run the IntersectionObserver logic on screens 901px and above
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        const video = entry.target;
        if (entry.isIntersecting) {
          // Play the video when it's fully visible
          video.play();
          // Stop observing the video once it has started playing
          observer.unobserve(video);
        }
      });
    }, {
      threshold: 1.0 // 1.0 means the video must be 100% visible in the viewport
    });

    videos.forEach(video => {
      observer.observe(video);
    });
  } else {
    videos.forEach(video => {
      video.play();
    });
  }
}
handleVideos();
});
